import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useShowFilters } from '../context';

export const FilterChips = () => {
  const { t } = useTranslation();
  const { filters, setFilter } = useShowFilters();
  const items = filters.tags.items;

  const toggleItem = (value: string) => {
    const newItems = items.map((item) =>
      item.value === value ? { ...item, selected: !item.selected } : item,
    );
    setFilter({ field: 'tags', items: newItems });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {items
        .filter((f) => f.selected)
        .map((f) => (
          <Chip
            key={`tag-${f.value}`}
            label={`${t('pages.shows.list.filters.tag')}: ${f.label}`}
            color="primary"
            onDelete={() => {
              // Toggle off this tag
              toggleItem(f.value);
            }}
          />
        ))}
    </Box>
  );
};
